import styles from "./topbar.module.css";
import { FiFacebook } from "react-icons/fi";
import { FaPinterestP } from "react-icons/fa6";
import { IoLogoInstagram } from "react-icons/io";
import { PiYoutubeLogo } from "react-icons/pi";
import { BsTelephone } from "react-icons/bs";
import { CiMail } from "react-icons/ci";

const TopBar = () => {
  return (
    <div className={styles.banner}>
      <div className={styles.banner__container}>
        <div className={styles.banner__contact}>
          <div className={styles.banner__contact_item}>
            <BsTelephone size={18} />
            <a href="tel:+918888893938">+91  8886060799</a>
          </div>
          <div className={styles.banner__contact_item}>
            <CiMail size={18} />
            <a
              href="https://mail.google.com/mail/?view=cm&fs=1&to=info@gdrbtechnologies.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              info@gdrbtechnologies.com
            </a>
          </div>
        </div>
        <div className={styles.banner__social}>
          <a
            href="https://www.facebook.com/p/GDRB-Technologies-Pvt-Ltd-100088258881230/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FiFacebook className={styles.banner__social_icon} size={18} />
          </a>
          <a
            href="https://www.instagram.com/gdrbtechnologies/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoInstagram className={styles.banner__social_icon} size={18} />
          </a>
          <a
            href="https://www.youtube.com/@gdrbtechnologies"
            target="_blank"
            rel="noopener noreferrer"
          >
            <PiYoutubeLogo className={styles.banner__social_icon} size={18} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;